import { ApiCreditcard } from '@/models/api/creditcard'
import {
  FailedToRemoveOldCreditcardError,
  RegisterCreditcardToSubscribePlanError,
} from '@/models/paid-membership/subscribe/errors'
import { CreditcardForSubscriptionRepository } from '@/models/payment/creditcard/context/for-subscription/repository'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import { User } from '@spa/store/modules/user/types'
import { ActionExecutor, ActionRequestList, AtMostOneRedirectWithHtmlRule } from '../../../action/action'
import { RegisterUseCaseContext, registerWithout3DSecureOnlyForMainCardContext } from '../../../service/register-new-creditcard'

interface CreditcardChangeDependencies {
  creditcard: {
    oldCard: ApiCreditcard
    newCard: CreditcardFormState
  }
}
/**
 * サブスクリプション支払い用のクレジットカード変更手続き.
 *
 * 登録可能なクレカは1つのみのため、もし登録済みカードがある場合は古い方を削除してから登録する.
 * @see CreditcardForSubscriptionRepository.findRegistered
 */
export async function changeCreditcardForSubscription(
  repository: CreditcardForSubscriptionRepository,
  { creditcard }: CreditcardChangeDependencies,
  user: User,
  context: RegisterUseCaseContext = registerWithout3DSecureOnlyForMainCardContext
): Promise<void> {
  await repository.remove(creditcard.oldCard.id).catch((error) => {
    throw RegisterCreditcardToSubscribePlanError.causedBy(error, FailedToRemoveOldCreditcardError)
  })

  const result = new ActionRequestList([
    await repository.register(creditcard.newCard, user, context),
  ])

  await Promise.all(
    new ActionExecutor(new AtMostOneRedirectWithHtmlRule()).execute(result)
  )
}
